'use strict';

Object.defineProperty(exports, "__esModule", {
    value: true
});

var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _reactIconBase = require('react-icon-base');

var _reactIconBase2 = _interopRequireDefault(_reactIconBase);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var IoSocialGithub = function IoSocialGithub(props) {
    return _react2.default.createElement(
        _reactIconBase2.default,
        _extends({ viewBox: '0 0 40 40' }, props),
        _react2.default.createElement(
            'g',
            null,
            _react2.default.createElement('path', { d: 'm17.5 2.5c9.7 0 17.5 8 17.5 18 0 7.9-5 14.7-12 17h-0.3c-0.6 0-0.9-0.5-0.9-0.9 0-0.7 0.1-2.5 0.1-4.9 0-1.6-0.7-2.8-1.3-3.3 3.9-0.5 8.1-2 8.1-8.9 0-1.9-0.7-3.6-1.8-4.8 0.1-0.5 0.8-2.3-0.2-4.8h-0.4c-0.6 0-2.1 0.3-4.4 1.9-1.4-0.4-2.9-0.6-4.4-0.6s-3 0.2-4.4 0.6c-2.3-1.6-3.8-1.9-4.4-1.9h-0.4c-1 2.5-0.3 4.3-0.2 4.8-1.1 1.2-1.8 2.9-1.8 4.8 0 6.9 4.1 8.4 8 8.9-0.5 0.4-0.9 1.2-1.1 2.4-0.5 0.2-1.2 0.5-2 0.5-1 0-2.2-0.4-3.1-2 0 0-1-1.7-2.7-1.9-0.2 0-1.7 0-0.1 1.1 0 0 1.2 0.6 2 2.7 0 0 0.7 2.6 4.1 2.6 0.6 0 1.1 0 1.7-0.2v3c0 0.4-0.2 0.9-0.8 0.9h-0.3c-7-2.3-12-9.1-12-17 0-10 7.8-18 17.5-18z' })
        )
    );
};

exports.default = IoSocialGithub;
module.exports = exports['default'];


//////////////////
// WEBPACK FOOTER
// ./~/react-icons/lib/io/social-github.js
// module id = 2678
// module chunks = 0